import { render, staticRenderFns } from "./GiftModal.vue?vue&type=template&id=4024486f&"
import script from "./GiftModal.vue?vue&type=script&lang=js&"
export * from "./GiftModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports